import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import PriceLabel from '@components/PriceLabel';
import { ICurrency } from '@containers/App/model';

import { useIsDualPriceForCroatia } from '../../hooks/useIsDualPriceForCroatia';
import { messages } from '../ProductDiscount/messages';
import { Line } from '../SelectedVariant/styled';

import { Wrapper, CurrencyWrapper, LineWrapper, Slash } from './styled';
import {
  IVoucherDiscountInfoProps,
  VoucherDiscountInfo,
} from './VoucherDiscountInfo';

interface IVoucherDiscount {
  displayType: 'DiscountedPrice' | 'Percentage';
  percentage: number;
  discountedPrice: number;
  code: string;
  icon: IVoucherDiscountInfoProps['icon'];
}

export interface IVoucherDiscountProps {
  voucherDiscount: IVoucherDiscount;
  currency: ICurrency;
  isUnderSelectBox?: boolean;
}

export const VoucherDiscount = ({
  voucherDiscount: { displayType, discountedPrice, icon, percentage, code },
  currency,
  isUnderSelectBox,
}: IVoucherDiscountProps) => {
  const {
    isDualPriceForCroatia,
    getLeftSideFormattedPrice,
    leftSideCurrency,
    rightSideCurrency,
    getRightSidePrice,
  } = useIsDualPriceForCroatia();
  return (
    <>
      <VoucherDiscountInfo
        icon={icon}
        percentage={percentage}
        discountCode={code}
        isUnderSelectBox={isUnderSelectBox}
        discountAmount={
          displayType === 'Percentage' ? (
            <FormattedMessage
              {...messages.discountAmount}
              values={{
                amount: percentage,
              }}
            />
          ) : (
            <>
              {isDualPriceForCroatia && (
                <Wrapper>
                  {getLeftSideFormattedPrice(discountedPrice)}{' '}
                  <CurrencyWrapper>{leftSideCurrency}</CurrencyWrapper>
                  <Slash>/</Slash>
                </Wrapper>
              )}
              <PriceLabel
                price={{
                  value: isDualPriceForCroatia
                    ? getRightSidePrice(discountedPrice)
                    : discountedPrice,
                  currency: currency.code,
                }}
                wrapperComponent={Wrapper}
                currencyComponent={CurrencyWrapper}
                currencySymbolOverride={
                  isDualPriceForCroatia ? rightSideCurrency : undefined
                }
              />
            </>
          )
        }
      />
      <LineWrapper>
        <Line dashedLine={true} />
      </LineWrapper>
    </>
  );
};
